import { Input, Component, OnInit } from '@angular/core';

@Component({
    selector: 'stock-item',
    template: require('./stock-item.component.html'),
    styles: [require('./stock-item.component.css')]
})
export class StockItemComponent implements OnInit {
    @Input() item: object;

    ngOnInit(): void {
        
    }
}